import { useEffect, useState } from "react";
import CameraRight from "./camera/CameraRight";
import MicRight from "./mic/MicRight";
import InternetRight from "./internet/InternetRight";
import InstructionRight from "./instruction/InstructionRight";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { examSetupSteps } from "../../../constant/Constants";
import { Button } from "../../../components";
import ScreenRecRight from "./screenRecording/ScreenRecRight";

const SetupRight = ({
  step,
  hasCameraPermission,
  hasMicPermission,
  isMicWorking,
  hasInternetConnection,
}) => {
  const navigate = useNavigate();
  const steps = examSetupSteps;

  const handleNext = () => {
    const stpNo = steps?.findIndex((stp) => stp === step);
    navigate(
      steps.length === stpNo + 1
        ? `/exam/instructions`
        : `/exam/setup/${steps[stpNo + 1]}`
    );
  };

  const recordingStatus = useSelector(
    (state) => state.screenRecording.recordingStatus
  );

  const [isNextDisabled, setIsNextDisabled] = useState(true);
  useEffect(() => {
    switch (step) {
      case "camera":
        setIsNextDisabled(!hasCameraPermission);
        break;
      case "mic":
        setIsNextDisabled(!isMicWorking || !hasMicPermission);
        break;
      case "internet":
        setIsNextDisabled(!hasInternetConnection);
        break;
      case "screenRecording":
        setIsNextDisabled(recordingStatus !== "recording");
        break;
      default:
        setIsNextDisabled(false);
    }
  }, [
    steps,
    step,
    hasCameraPermission,
    isMicWorking,
    hasMicPermission,
    hasInternetConnection,
    recordingStatus,
  ]);

  return (
    <>
      {step === "camera" && <CameraRight />}

      {step === "mic" && <MicRight />}
      {step === "internet" && <InternetRight />}
      {step === "screenRecording" && <ScreenRecRight />}
      {step === "instruction" && <InstructionRight />}

      <div className="ml-[10%] mb-5">
        <Button
          version="secondary"
          text="Proceed"
          handleClick={handleNext}
          width="8rem"
          isDisabled={isNextDisabled}
        />
      </div>
    </>
  );
};

export default SetupRight;
